// removed by extract-text-webpack-plugin
module.exports = {"list":"antd-pro-list","item":"antd-pro-item","meta":"antd-pro-meta","avatar":"antd-pro-avatar","read":"antd-pro-read","title":"antd-pro-title","description":"antd-pro-description","datetime":"antd-pro-datetime","extra":"antd-pro-extra","notFound":"antd-pro-notFound","clear":"antd-pro-clear"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/NoticeList.less
// module id = 375
// module chunks = 0 1